import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Login from "../pages/auth/Login";
import Register from "../pages/auth/Register";
import Dashboard from "../pages/dashboard/page";
import Assets from "../pages/assets/page";
import Maintenance from "../pages/maintenance/page";
import Invoices from "../pages/invoices/page";
import Reports from "../pages/reports/page";
import Settings from "../pages/settings/page";
import AssetsRegister from "../pages/assets-register/page";
import FieldBuilderPage from '../pages/field-builder/page';

/**
 * Application route configuration.
 * All JSX elements are now correctly written using standard JSX syntax.
 * If a route component fails to render, React Router will fall back to the
 * NotFound page defined at the end of the array.
 */
const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/login" replace />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/assets",
    element: <Assets />,
  },
  {
    path: "/assets/register",
    element: <AssetsRegister />,
  },
  {
    path: "/assets/register/:chNfe",
    element: <AssetsRegister />,
  },
  {
    path: "/maintenance",
    element: <Maintenance />,
  },
  {
    path: "/invoices",
    element: <Invoices />,
  },
  {
    path: "/reports",
    element: <Reports />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/field-builder",
    element: <FieldBuilderPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
